<script>
  import configStore from './configStore';
</script>

{#if $configStore.legalText}
  <p class="text-sm text-gray-500 mb-0">
    {$configStore.legalText}
  </p>
{/if}
